import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1a3e09d8 = () => interopDefault(import('../../../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _4c4782b2 = () => interopDefault(import('../../../pages/clubs/index.vue' /* webpackChunkName: "pages/clubs/index" */))
const _2b33f6da = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _0e35ff1a = () => interopDefault(import('../../../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _c42efd0c = () => interopDefault(import('../../../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _c3be3278 = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _a91da526 = () => interopDefault(import('../../../pages/typo.vue' /* webpackChunkName: "pages/typo" */))
const _ed403e12 = () => interopDefault(import('../../../pages/clubs/create.vue' /* webpackChunkName: "pages/clubs/create" */))
const _2aa55416 = () => interopDefault(import('../../../pages/clubs/denied.vue' /* webpackChunkName: "pages/clubs/denied" */))
const _c6f9054e = () => interopDefault(import('../../../pages/clubs/messaging.vue' /* webpackChunkName: "pages/clubs/messaging" */))
const _ab272040 = () => interopDefault(import('../../../pages/helloasso/auth.vue' /* webpackChunkName: "pages/helloasso/auth" */))
const _7dcb4bfd = () => interopDefault(import('../../../pages/helloasso/callback.vue' /* webpackChunkName: "pages/helloasso/callback" */))
const _2f97743e = () => interopDefault(import('../../../pages/helloasso/login.vue' /* webpackChunkName: "pages/helloasso/login" */))
const _6aae6350 = () => interopDefault(import('../../../pages/helloasso/signup.vue' /* webpackChunkName: "pages/helloasso/signup" */))
const _3a4a8dbe = () => interopDefault(import('../../../pages/auth/callback/apple.vue' /* webpackChunkName: "pages/auth/callback/apple" */))
const _e8cfbbdc = () => interopDefault(import('../../../pages/auth/callback/facebook.vue' /* webpackChunkName: "pages/auth/callback/facebook" */))
const _652da6f9 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _d31528ce = () => interopDefault(import('../../../pages/players/payment-request/_payment_id/token/_token.vue' /* webpackChunkName: "pages/players/payment-request/_payment_id/token/_token" */))
const _bc29367e = () => interopDefault(import('../../../pages/players/payment-result/_payment_id/token/_token.vue' /* webpackChunkName: "pages/players/payment-result/_payment_id/token/_token" */))
const _1472cbca = () => interopDefault(import('../../../pages/players/payment/_payment_id/token/_token.vue' /* webpackChunkName: "pages/players/payment/_payment_id/token/_token" */))
const _67576d43 = () => interopDefault(import('../../../pages/clubs/_club_id/index.vue' /* webpackChunkName: "pages/clubs/_club_id/index" */))
const _11b256de = () => interopDefault(import('../../../pages/clubs/_club_id/account.vue' /* webpackChunkName: "pages/clubs/_club_id/account" */))
const _f9d19118 = () => interopDefault(import('../../../pages/clubs/_club_id/accounting.vue' /* webpackChunkName: "pages/clubs/_club_id/accounting" */))
const _7bb730a8 = () => interopDefault(import('../../../pages/clubs/_club_id/approval-pending.vue' /* webpackChunkName: "pages/clubs/_club_id/approval-pending" */))
const _e2d47560 = () => interopDefault(import('../../../pages/clubs/_club_id/awaiting-players.vue' /* webpackChunkName: "pages/clubs/_club_id/awaiting-players" */))
const _2de3080a = () => interopDefault(import('../../../pages/clubs/_club_id/events/index.vue' /* webpackChunkName: "pages/clubs/_club_id/events/index" */))
const _57810e90 = () => interopDefault(import('../../../pages/clubs/_club_id/messaging/index.vue' /* webpackChunkName: "pages/clubs/_club_id/messaging/index" */))
const _6cd10468 = () => interopDefault(import('../../../pages/clubs/_club_id/payments.vue' /* webpackChunkName: "pages/clubs/_club_id/payments" */))
const _38471426 = () => interopDefault(import('../../../pages/clubs/_club_id/players/index.vue' /* webpackChunkName: "pages/clubs/_club_id/players/index" */))
const _0fe757c4 = () => interopDefault(import('../../../pages/clubs/_club_id/posts.vue' /* webpackChunkName: "pages/clubs/_club_id/posts" */))
const _637eecc5 = () => interopDefault(import('../../../pages/clubs/_club_id/settings/index.vue' /* webpackChunkName: "pages/clubs/_club_id/settings/index" */))
const _743faf02 = () => interopDefault(import('../../../pages/clubs/_club_id/statistics.vue' /* webpackChunkName: "pages/clubs/_club_id/statistics" */))
const _9ae46d2c = () => interopDefault(import('../../../pages/clubs/_club_id/teams/index.vue' /* webpackChunkName: "pages/clubs/_club_id/teams/index" */))
const _328060b6 = () => interopDefault(import('../../../pages/clubs/_club_id/events/calendar.vue' /* webpackChunkName: "pages/clubs/_club_id/events/calendar" */))
const _59cb6df9 = () => interopDefault(import('../../../pages/clubs/_club_id/events/past.vue' /* webpackChunkName: "pages/clubs/_club_id/events/past" */))
const _1150886c = () => interopDefault(import('../../../pages/clubs/_club_id/messaging/archived.vue' /* webpackChunkName: "pages/clubs/_club_id/messaging/archived" */))
const _81a58dce = () => interopDefault(import('../../../pages/clubs/_club_id/settings/bank.vue' /* webpackChunkName: "pages/clubs/_club_id/settings/bank" */))
const _e50bec32 = () => interopDefault(import('../../../pages/clubs/_club_id/settings/edit.vue' /* webpackChunkName: "pages/clubs/_club_id/settings/edit" */))
const _e259c30c = () => interopDefault(import('../../../pages/clubs/_club_id/settings/subscription.vue' /* webpackChunkName: "pages/clubs/_club_id/settings/subscription" */))
const _7240a2d8 = () => interopDefault(import('../../../pages/clubs/_club_id/teams/create.vue' /* webpackChunkName: "pages/clubs/_club_id/teams/create" */))
const _71470178 = () => interopDefault(import('../../../pages/clubs/_club_id/events/event/create.vue' /* webpackChunkName: "pages/clubs/_club_id/events/event/create" */))
const _823ffd26 = () => interopDefault(import('../../../pages/clubs/_club_id/events/match/create.vue' /* webpackChunkName: "pages/clubs/_club_id/events/match/create" */))
const _4b2e95d1 = () => interopDefault(import('../../../pages/clubs/_club_id/events/training-session/create.vue' /* webpackChunkName: "pages/clubs/_club_id/events/training-session/create" */))
const _52fceb36 = () => interopDefault(import('../../../pages/clubs/_club_id/events/event/_event_id/index.vue' /* webpackChunkName: "pages/clubs/_club_id/events/event/_event_id/index" */))
const _7b47e23e = () => interopDefault(import('../../../pages/clubs/_club_id/events/match/_event_id/index.vue' /* webpackChunkName: "pages/clubs/_club_id/events/match/_event_id/index" */))
const _0fe42afd = () => interopDefault(import('../../../pages/clubs/_club_id/events/training-session/_event_id/index.vue' /* webpackChunkName: "pages/clubs/_club_id/events/training-session/_event_id/index" */))
const _a40c0d54 = () => interopDefault(import('../../../pages/clubs/_club_id/events/event/_event_id/edit.vue' /* webpackChunkName: "pages/clubs/_club_id/events/event/_event_id/edit" */))
const _18bb976a = () => interopDefault(import('../../../pages/clubs/_club_id/events/match/_event_id/edit.vue' /* webpackChunkName: "pages/clubs/_club_id/events/match/_event_id/edit" */))
const _664fb6a2 = () => interopDefault(import('../../../pages/clubs/_club_id/events/training-session/_event_id/edit.vue' /* webpackChunkName: "pages/clubs/_club_id/events/training-session/_event_id/edit" */))
const _35ee4119 = () => interopDefault(import('../../../pages/clubs/_club_id/players/_player_id/index.vue' /* webpackChunkName: "pages/clubs/_club_id/players/_player_id/index" */))
const _7415f493 = () => interopDefault(import('../../../pages/clubs/_club_id/teams/_team_id/edit.vue' /* webpackChunkName: "pages/clubs/_club_id/teams/_team_id/edit" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _1a3e09d8,
    name: "account"
  }, {
    path: "/clubs",
    component: _4c4782b2,
    name: "clubs"
  }, {
    path: "/login",
    component: _2b33f6da,
    name: "login"
  }, {
    path: "/logout",
    component: _0e35ff1a,
    name: "logout"
  }, {
    path: "/maintenance",
    component: _c42efd0c,
    name: "maintenance"
  }, {
    path: "/signup",
    component: _c3be3278,
    name: "signup"
  }, {
    path: "/typo",
    component: _a91da526,
    name: "typo"
  }, {
    path: "/clubs/create",
    component: _ed403e12,
    name: "clubs-create"
  }, {
    path: "/clubs/denied",
    component: _2aa55416,
    name: "clubs-denied"
  }, {
    path: "/clubs/messaging",
    component: _c6f9054e,
    name: "clubs-messaging"
  }, {
    path: "/helloasso/auth",
    component: _ab272040,
    name: "helloasso-auth"
  }, {
    path: "/helloasso/callback",
    component: _7dcb4bfd,
    name: "helloasso-callback"
  }, {
    path: "/helloasso/login",
    component: _2f97743e,
    name: "helloasso-login"
  }, {
    path: "/helloasso/signup",
    component: _6aae6350,
    name: "helloasso-signup"
  }, {
    path: "/auth/callback/apple",
    component: _3a4a8dbe,
    name: "auth-callback-apple"
  }, {
    path: "/auth/callback/facebook",
    component: _e8cfbbdc,
    name: "auth-callback-facebook"
  }, {
    path: "/",
    component: _652da6f9,
    name: "index"
  }, {
    path: "/players/payment-request/:payment_id?/token/:token?",
    component: _d31528ce,
    name: "players-payment-request-payment_id-token-token"
  }, {
    path: "/players/payment-result/:payment_id?/token/:token?",
    component: _bc29367e,
    name: "players-payment-result-payment_id-token-token"
  }, {
    path: "/players/payment/:payment_id?/token/:token?",
    component: _1472cbca,
    name: "players-payment-payment_id-token-token"
  }, {
    path: "/clubs/:club_id",
    component: _67576d43,
    name: "clubs-club_id"
  }, {
    path: "/clubs/:club_id/account",
    component: _11b256de,
    name: "clubs-club_id-account"
  }, {
    path: "/clubs/:club_id/accounting",
    component: _f9d19118,
    name: "clubs-club_id-accounting"
  }, {
    path: "/clubs/:club_id/approval-pending",
    component: _7bb730a8,
    name: "clubs-club_id-approval-pending"
  }, {
    path: "/clubs/:club_id/awaiting-players",
    component: _e2d47560,
    name: "clubs-club_id-awaiting-players"
  }, {
    path: "/clubs/:club_id/events",
    component: _2de3080a,
    name: "clubs-club_id-events"
  }, {
    path: "/clubs/:club_id/messaging",
    component: _57810e90,
    name: "clubs-club_id-messaging"
  }, {
    path: "/clubs/:club_id/payments",
    component: _6cd10468,
    name: "clubs-club_id-payments"
  }, {
    path: "/clubs/:club_id/players",
    component: _38471426,
    name: "clubs-club_id-players"
  }, {
    path: "/clubs/:club_id/posts",
    component: _0fe757c4,
    name: "clubs-club_id-posts"
  }, {
    path: "/clubs/:club_id/settings",
    component: _637eecc5,
    name: "clubs-club_id-settings"
  }, {
    path: "/clubs/:club_id/statistics",
    component: _743faf02,
    name: "clubs-club_id-statistics"
  }, {
    path: "/clubs/:club_id/teams",
    component: _9ae46d2c,
    name: "clubs-club_id-teams"
  }, {
    path: "/clubs/:club_id/events/calendar",
    component: _328060b6,
    name: "clubs-club_id-events-calendar"
  }, {
    path: "/clubs/:club_id/events/past",
    component: _59cb6df9,
    name: "clubs-club_id-events-past"
  }, {
    path: "/clubs/:club_id/messaging/archived",
    component: _1150886c,
    name: "clubs-club_id-messaging-archived"
  }, {
    path: "/clubs/:club_id/settings/bank",
    component: _81a58dce,
    name: "clubs-club_id-settings-bank"
  }, {
    path: "/clubs/:club_id/settings/edit",
    component: _e50bec32,
    name: "clubs-club_id-settings-edit"
  }, {
    path: "/clubs/:club_id/settings/subscription",
    component: _e259c30c,
    name: "clubs-club_id-settings-subscription"
  }, {
    path: "/clubs/:club_id/teams/create",
    component: _7240a2d8,
    name: "clubs-club_id-teams-create"
  }, {
    path: "/clubs/:club_id/events/event/create",
    component: _71470178,
    name: "clubs-club_id-events-event-create"
  }, {
    path: "/clubs/:club_id/events/match/create",
    component: _823ffd26,
    name: "clubs-club_id-events-match-create"
  }, {
    path: "/clubs/:club_id/events/training-session/create",
    component: _4b2e95d1,
    name: "clubs-club_id-events-training-session-create"
  }, {
    path: "/clubs/:club_id/events/event/:event_id",
    component: _52fceb36,
    name: "clubs-club_id-events-event-event_id"
  }, {
    path: "/clubs/:club_id/events/match/:event_id",
    component: _7b47e23e,
    name: "clubs-club_id-events-match-event_id"
  }, {
    path: "/clubs/:club_id/events/training-session/:event_id",
    component: _0fe42afd,
    name: "clubs-club_id-events-training-session-event_id"
  }, {
    path: "/clubs/:club_id/events/event/:event_id?/edit",
    component: _a40c0d54,
    name: "clubs-club_id-events-event-event_id-edit"
  }, {
    path: "/clubs/:club_id/events/match/:event_id?/edit",
    component: _18bb976a,
    name: "clubs-club_id-events-match-event_id-edit"
  }, {
    path: "/clubs/:club_id/events/training-session/:event_id?/edit",
    component: _664fb6a2,
    name: "clubs-club_id-events-training-session-event_id-edit"
  }, {
    path: "/clubs/:club_id/players/:player_id",
    component: _35ee4119,
    name: "clubs-club_id-players-player_id"
  }, {
    path: "/clubs/:club_id/teams/:team_id/edit",
    component: _7415f493,
    name: "clubs-club_id-teams-team_id-edit"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
